const lightTheme = {
    // Common
    applicationBackground: "#EDF2F7",
    routerLink: "#C6CACC",
    routerLinkHover: "#165C85",
    routerLinkActive: "#20739C",
    routerLinkActiveHover: "#20739C",
    iconButton: "#4A4A4A",
    iconButtonHover: "#185A7A",
    textButton: "#185A7A",
    hyperlink: "#4A4A4A",
    iconTrayBackground: "#000000",
    iconTrayIcon: "#FFFFFF",
    iconTrayIconHover: "#258DBF",
    navigationBackground: "#141617",

    // Home
    background: "#141617",
    accent: "#20739C",
    contentText: "#C6CACC",

    // About


    // Experience
    companyName: "#20739C",
    positionTitle: "#165C85",
    companyLocation: "#165C85",
    positionDates: "#2E3438",

    // Education
    educationTitle: "#20739C",
    educationSubtitle: "#165C85",
    educationText: "#2E3438",

    // Projects


    // Connect
}

export default lightTheme;